export default "__VITE_ASSET__JtTKynmx__"